import React from "react";

export const CreateAssistantIcon = (props) => {
  return (
    <span className="icon icon--chats">
      <svg
        width={22}
        height={22}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 6.9999C20.5304 6.9999 21.0391 7.21061 21.4142 7.58569C21.7893 7.96076 22 8.46947 22 8.9999V12.9999C22 13.5303 21.7893 14.039 21.4142 14.4141C21.0391 14.7892 20.5304 14.9999 20 14.9999H18.938C18.6942 16.9332 17.7533 18.7111 16.2917 19.9999C14.8302 21.2887 12.9486 21.9999 11 21.9999V19.9999C12.5913 19.9999 14.1174 19.3678 15.2426 18.2425C16.3679 17.1173 17 15.5912 17 13.9999V7.9999C17 6.4086 16.3679 4.88248 15.2426 3.75726C14.1174 2.63204 12.5913 1.9999 11 1.9999C9.4087 1.9999 7.88258 2.63204 6.75736 3.75726C5.63214 4.88248 5 6.4086 5 7.9999V14.9999H2C1.46957 14.9999 0.960859 14.7892 0.585786 14.4141C0.210714 14.039 0 13.5303 0 12.9999V8.9999C0 8.46947 0.210714 7.96076 0.585786 7.58569C0.960859 7.21061 1.46957 6.9999 2 6.9999H3.062C3.30603 5.0668 4.24708 3.28917 5.70857 2.00058C7.17007 0.711979 9.05155 0.000976562 11 0.000976562C12.9484 0.000976562 14.8299 0.711979 16.2914 2.00058C17.7529 3.28917 18.694 5.0668 18.938 6.9999H20ZM6.76 14.7849L7.82 13.0889C8.77308 13.6859 9.87537 14.0017 11 13.9999C12.1246 14.0017 13.2269 13.6859 14.18 13.0889L15.24 14.7849C13.9693 15.581 12.4995 16.0022 11 15.9999C9.50046 16.0022 8.03074 15.581 6.76 14.7849Z"
          fill="#B1B1B1"
        />
      </svg>
    </span>
  );
};
